'use client';
import React, { useState } from 'react';
import Button from '@/components/ui/Button';
import Slider from '@/components/ui/Slider';
import useSharedRef from '@/hooks/useSharedRef';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import IndustryHighlights from '@/components/about/IndustryHighlightsNew';
export default function HomePage() {
  const modalRef = useSharedRef('modalRef');
  const [email, setEmail] = useState('');
  const router = useRouter();
  return (
    <>
      <div className="w-full max-w-[1440px] flex flex-col items-center gap-[3.75rem]">
        <div className="w-full max-w-[1440px] flex flex-col items-center gap-[3rem]">
          {/* Hero Section */}
          <section className="w-full  mx-auto flex flex-col items-center gap-12 lg:gap-14 px-4 sm:px-14 md:px-18 lg:px-[4.5rem]">
            {/* Hero Text Section */}
            <div className="w-full flex flex-col items-center gap-6 sm:gap-7 md:gap-9">
              <h1 className="leading-tight sm:leading-[128%] md:leading-[128%] lg:leading-[128%] text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium font-ibm-plex text-center text-[#212a31] max-w-3xl ">
                The Autonomous Fab is Here
              </h1>
              <p className="text-base sm:leading-[160%] md:leading-[160%] lg:leading-[160%] sm:text-[1.125rem] md:text-[1.25rem] font-normal font-ibm-plex text-center text-[#212a31] max-w-7xl">
                Unlock 95% of your fab's hidden intelligence. Our AI predicts and prevents
                costly excursions to slash scrap costs, cut cycle time by 30%, and scale your output 1.3x—all without new CAPEX.
              </p>
            </div>
            {/* Email Input Section */}
            <div className="w-full max-w-md sm:max-w-lg md:max-w-xl flex items-center bg-white border border-[#eaeaea] rounded-md shadow-[0px_4px_64px_#00000014] p-2">
              <input
                type="email"
                placeholder="Enter your email address"
                className="flex-1 px-3 py-2 text-sm sm:text-base text-[#324452] font-inter bg-transparent border-none outline-none"
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button
                variant="primary"
                size="sm"
                type="submit"
                className="bg-[#1449ea] text-white px-3 py-2 sm:px-4 sm:py-2.5 text-sm sm:text-base font-normal font-ibm-plex rounded-md"
                onClick={() => {
                  modalRef?.current?.open?.(email);
                  setEmail('');
                }}
              >
                Book a Demo
              </Button>
            </div>
          </section>
          <section className="w-full max-w-[1440px] mx-auto flex justify-center max-h-[35rem] items-center gap-12 lg:gap-14 px-4 sm:px-12 md:px-18 lg:px-[4.5rem]">
            {/* Dashboard Image Section */}
            <img
              src="/images/img_home_hero.webp"
              alt="AI Dashboard Interface"
              className="relative max-w-[803px] max-h-full w-full h-full rounded-lg object-cover mx-auto"
            />
          </section>
        </div>
        <section className="w-full max-w-[1440px] mx-auto flex flex-col justify-center items-center gap-12 lg:gap-14 px-4 sm:px-12 md:px-18 lg:px-[4.5rem]">
          {/* Trusted Companies Section */}
          <div className="w-full flex flex-col items-center gap-10 sm:gap-10 ">
            <h2 className="sm:leading-[160%] text-xl sm:text-2xl font-medium font-ibm-plex text-center text-[#212a31]">
              Trusted by Top Semiconductor companies
            </h2>
            <div className='flex flex-col items-center gap-4'>
              <div className="flex flex-wrap justify-center items-center gap-8 sm:gap-10 md:gap-12">
                <img src="/images/img_image_22.png" alt="Company 1" className="h-8 sm:h-10 w-auto" />
                <img src="/images/img_image_logo_statschip.png" alt="Company 2" className="h-12 sm:h-16 w-auto" />
                <img src="/images/img_image_logo_raytek.png" alt="Company 3" className="h-12 sm:h-16 w-auto" />
                <img src="/images/img_image_logo_wavetek.png" alt="Wavetek" className="h-12 sm:h-16 w-auto" />
                <img src="/images/img_image_logo_theil.png" alt="theil" className="h-12 sm:h-16 w-auto" />
              </div>
              <div className="sm:leading-[160%] md:leading-[160%] lg:leading-[160%] text-[0.875rem] text-center lg:max-w-full font-medium font-ibm-plex text-[#212a31]">
                Including many other industry leader across Singapore, Taiwan, Malaysia, China,
                Israel and US.
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* Case Study Banner */}
      <section className="w-full mx-auto flex flex-col items-center gap-12 lg:gap-14">
        <div className="w-full bg-[#e1effe] rounded-md p-4 sm:p-6 md:p-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <p className="sm:leading-[160%] md:leading-[160%] lg:leading-[160%] text-[1rem] sm:text-xl font-medium font-ibm-plex text-[#212a31] text-center sm:text-left">
            Inside classifAI: How AI is Revolutionizing Defect Classification in Fabs & OSATs.
          </p>
          <Link
            href="/ai_classification_blog.pdf"
            className="sm:leading-[160%] md:leading-[160%] lg:leading-[160%] text-[1rem] sm:text-xl font-medium font-ibm-plex text-[#2067f3] cursor-pointer hover:underline"
          >
            Read Now
          </Link>
        </div>
      </section>
      {/* AI Control Room Section */}
      <section className="w-full flex flex-col items-center gap-8 sm:gap-10 md:gap-12 px-4 sm:px-12 md:px-18 lg:px-20">
        <div className="w-full max-w-[1260px] mx-auto flex flex-col items-center gap-8 sm:gap-10">
          {/* Solutions Cards Title*/}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium font-ibm-plex text-center text-[#212a31] px-4 sm:px-8">
            Your Fab's AI Control Room: Our Flagship Solutions
          </h2>
        </div>
        <div className="w-full max-w-[1260px] mx-auto flex flex-col items-center gap-8 sm:gap-10">
          <div className="w-full flex flex-col gap-6">
            {/* Solution 1 - Overview */}
            <div className="w-full bg-[#fafafb] border border-[#e1eefe] rounded-lg p-4 sm:p-6 md:p-8 shadow-[0px_4px_64px_#00000014]">
              <div className="bg-transparent rounded-xl">
                <div className="flex flex-col-reverse lg:flex-row gap-8">
                  {/* Text Content */}
                  <div className="flex-1 items-center sm:items-start flex flex-col justify-center gap-8">
                    <div className="flex flex-col gap-5">
                      <p className="sm:leading-[160%] text-center sm:text-left md:leading-[160%] lg:leading-[160%] text-md sm:text-[1rem] font-normal font-ibm-plex leading-relaxed text-[#212a31]">
                        Sixsense is a purpose-built AI platform for fabs and OSATs, automating
                        defect inspection to lot disposition to root cause analysis of defect.
                      </p>
                      <ol className="list-disc px-4">
                        <li className="sm:leading-[160%] text-center sm:text-left md:leading-[160%] lg:leading-[160%] text-md sm:text-[1rem] font-normal font-ibm-plex leading-relaxed text-[#212a31]">
                          <strong className="text-[#1F9AC3]">AI-ADC</strong> is our end-to-end
                          solution for{' '}
                          <strong className="text-[#1F9AC3]">automating visual inspection</strong>,
                          with tools for training, deployment, and model maintenance.
                        </li>
                        <li className="sm:leading-[160%] text-center sm:text-left md:leading-[160%] lg:leading-[160%] text-md sm:text-[1rem] font-normal font-ibm-plex leading-relaxed text-[#212a31]">
                          <strong className="text-[#1F9AC3]">
                            Lot Disposition and Root-Cause Analysis
                          </strong>{' '}
                          brings intelligence to lot disposition by highlighting{' '}
                          <strong className="text-[#1F9AC3]">high-risk</strong> wafers based on
                          defect severity and yield impact. It helps prioritize reviews, recover
                          yield, and reduce escapes and scrap.
                        </li>
                        <li className="sm:leading-[160%] text-center sm:text-left md:leading-[160%] lg:leading-[160%] text-md sm:text-[1rem] font-normal font-ibm-plex leading-relaxed text-[#212a31]">
                          <strong className="text-[#1F9AC3]">Predict AI</strong> Go beyond
                          automation—AI predicts when, where, and{' '}
                          <strong className="text-[#1F9AC3]">
                            what to inspect, enabling proactive action
                          </strong>{' '}
                          that cuts scrap, reduces downtime, and drives{' '}
                          <strong className="text-[#1F9AC3]">self-optimizing fabs</strong>.
                        </li>
                      </ol>
                    </div>
                    <Button
                      variant="outline"
                      size="md"
                      className="w-fit border border-[#2250ce] text-[#2250ce] bg-white hover:bg-[#2250ce] py-2.5 sm:leading-[160%] md:leading-[160%] lg:leading-[160%] text-[1rem] sm:text-xl font-normal font-ibm-plex rounded-md"
                      onClick={() => {
                        router.push('/product');
                      }}
                    >
                      Explore More
                    </Button>
                  </div>
                  {/* Product Suite Visualization */}
                  <div className="bg-white flex-1 flex flex-col items-center px-5 gap-8 rounded-xl">
                    <img
                      src="/images/img_homepage_product_suite.svg"
                      alt="Sixsense Product Suite"
                      className="w-auto h-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Solution 2 - AI-ADC */}
            <div className="w-full bg-[#fafafb] border border-[#e1eefe] rounded-lg p-4 sm:p-6 md:p-8  shadow-[0px_4px_64px_#00000014]">
              <div className="rounded-xl">
                <div className="flex flex-col-reverse lg:flex-row gap-8">
                  {/* Text Content */}
                  <div className="flex-1 flex flex-col items-center sm:items-start justify-start gap-8">
                    <div className="flex flex-col gap-5">
                      <h3 className="sm:leading-[160%] text-center sm:text-left md:leading-[160%] lg:leading-[160%] text-[1rem] sm:text-xl font-bold font-ibm-plex text-[#212a31]">
                        <strong className="text-[#1F9AC3]">
                          AI-ADC: Automated Defect Classification at Line
                        </strong>
                      </h3>
                      <p className="sm:leading-[160%] text-center sm:text-left md:leading-[160%] lg:leading-[160%] text-md sm:text-[1rem] font-normal font-ibm-plex leading-relaxed text-[#212a31]">
                        AI-ADC is a real-time vision engine that analyzes every captured image and{' '}
                        <strong className="text-[#1F9AC3]">classifies suspected defects</strong>{' '}
                        into hundreds of types with over{' '}
                        <strong className="text-[#1F9AC3]">99% accuracy</strong> and{' '}
                        <strong className="text-[#1F9AC3]">zero escapee</strong>. It converts defect
                        images into meaningful insights at{' '}
                        <strong className="text-[#1F9AC3]">line speed</strong>—slashing review
                        queues, freeing clean-room{' '}
                        <strong className="text-[#1F9AC3]">headcount</strong>, and providing a
                        rock-solid foundation for{' '}
                        <strong className="text-[#1F9AC3]">downstream analytics</strong>. Fabs can
                        now scale without concerns about hiring, training, or human-driven quality
                        slips.
                      </p>
                    </div>
                    <Button
                      variant="outline"
                      size="md"
                      className="w-fit border border-[#2250ce] text-[#2250ce] bg-white hover:bg-[#2250ce] py-2.5 sm:leading-[160%] md:leading-[160%] lg:leading-[160%] text-[1rem] sm:text-xl font-normal font-ibm-plex rounded-md"
                      onClick={() => {
                        router.push('/product');
                      }}
                    >
                      Explore More
                    </Button>
                  </div>
                  {/* AI-ADC Process Flow */}
                  <img
                    src="/images/img_image_homepage_ai_adc_12.svg"
                    alt="AI-ADC Process Flow"
                    className="w-full h-full max-w-[601px]"
                  />
                </div>
              </div>
            </div>
            {/* Solution 3 - Lot Disposition */}
            <div className="w-full bg-[#fafafb] border border-[#e1eefe] rounded-lg p-4 sm:p-6 md:p-8 shadow-[0px_4px_64px_#00000014]">
              <div className="rounded-xl">
                <div className="flex flex-col-reverse lg:flex-row gap-8">
                  {/* Text Content */}
                  <div className="flex-1 flex flex-col items-center sm:items-start justify-start gap-8">
                    <div className="flex flex-col gap-5">
                      <h3 className="sm:leading-[160%] text-center sm:text-left md:leading-[160%] lg:leading-[160%] text-[1rem] sm:text-xl font-bold font-ibm-plex text-black">
                        <strong className="text-[#1F9AC3]">
                          Lot Disposition and Root-Cause Analysis
                        </strong>
                      </h3>
                      <p className="sm:leading-[160%] text-center sm:text-left md:leading-[160%] lg:leading-[160%] text-md sm:text-[1rem] font-normal font-ibm-plex leading-relaxed text-black">
                        Built on AI-ADC's trusted labels, Lot Disposition automatically decides{' '}
                        <strong className="text-[#1F9AC3]">pass, hold, rework, or scrap</strong> for
                        each lot—balancing yield impact, recurrence patterns, and defect severity.
                        Always-on AI agents{' '}
                        <strong className="text-[#1F9AC3]">correlate classified defects</strong>{' '}
                        with tool, recipe, and chamber data{' '}
                        <strong className="text-[#1F9AC3]">across hundreds of steps</strong>,
                        instantly{' '}
                        <strong className="text-[#1F9AC3]">
                          flagging parameters drifting out of spec
                        </strong>
                        , quantifying yield exposure, and surfacing the quickest fix. What once took
                        weeks now takes minutes—safeguarding future yield with speed and precision.
                      </p>
                    </div>
                    <Button
                      variant="outline"
                      size="md"
                      className="w-fit border border-[#2250ce] text-[#2250ce] bg-white hover:bg-[#2250ce] py-2.5 text-[1rem] sm:text-xl font-normal font-ibm-plex rounded-md"
                      onClick={() => {
                        router.push('/product');
                      }}
                    >
                      Explore More
                    </Button>
                  </div>
                  {/* Visualization */}
                  <img
                    src="/images/img_homepage_lot_disposition_1.svg"
                    alt="AI-ADC Process Flow"
                    className="w-full h-full max-w-[601px]"
                  />
                </div>
              </div>
            </div>
            {/* Solution 4 - Predict AI */}
            <div className="w-full bg-[#fafafb] border border-[#e1eefe] p-4 sm:p-6 md:p-8 rounded-lg shadow-[0px_4px_64px_#00000014]">
              <div>
                <div className="flex flex-col-reverse lg:flex-row gap-8">
                  {/* Text Content */}
                  <div className="flex-1 flex flex-col items-center sm:items-start justify-start gap-8">
                    <div className="flex flex-col gap-5">
                      <h3 className="text-[1rem] text-center sm:text-left sm:text-xl font-bold font-ibm-plex text-black">
                        <strong className="text-[#1F9AC3]">Predict AI</strong>
                      </h3>
                      <p className="text-md sm:text-[1rem] text-center sm:text-left font-normal font-ibm-plex leading-relaxed text-black">
                        Move beyond automation and correlation into prediction—where AI
                        intelligently forecasts{' '}
                        <strong className="text-[#1F9AC3]">when, where, and what</strong> to inspect
                        by learning defect likelihood across time, layers, and lots. These insights
                        trigger <strong className="text-[#1F9AC3]">proactive adjustments</strong> to
                        inspection sampling and <strong className="text-[#1F9AC3]">tools</strong>{' '}
                        before faults occur, dramatically reducing scrap and downtime. As a result,
                        fabs shift from reactive firefighting to self-optimizing production, guided
                        entirely by data-driven agents.
                      </p>
                    </div>
                    <Button
                      variant="outline"
                      size="md"
                      className="w-fit border border-[#2250ce] text-[#2250ce] bg-white hover:bg-[#2250ce] py-2.5 text-[1rem] sm:text-xl font-normal font-ibm-plex rounded-md"
                      onClick={() => {
                        router.push('/product');
                      }}
                    >
                      Explore More
                    </Button>
                  </div>
                  {/* Process Flow - Disabled State */}
                  <div className="bg-white flex-1 flex flex-col items-center px-6 pb-6 pt-2 rounded-xl">
                    {/* Predict AI Visualization */}
                    <img
                      src="/images/predict_ai.svg"
                      alt="Data Table"
                      className="w-[528px] h-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Proven Value Section */}
      <section className="w-full max-w-full bg-[#fafafb] py-6 sm:py-8 md:py-10 px-4 sm:px-12 md:px-18 lg:px-[4.5rem]">
        <div className="w-full max-w-[1260px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center gap-8 sm:gap-10">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium font-ibm-plex text-center pt-16 text-black px-2 sm:px-4">
              Proven Value, Measurable Impact
            </h2>
            {/* Impact Cards */}
            <div className="w-full flex flex-col gap-2 sm:gap-3">
              {/* Card 1 */}
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 sm:gap-8 p-6 sm:p-8">
                <div className="flex-shrink-0 w-20 sm:w-24 h-20 sm:h-24 bg-white border border-[#d7e7ff] rounded-lg flex items-center justify-center p-6 sm:p-7">
                  <img
                    src="/images/img_badge_dollar.svg"
                    alt="Dollar Badge"
                    className="w-12 sm:w-16 h-8 sm:h-12"
                  />
                </div>
                <div className="flex flex-col gap-4 sm:gap-5">
                  <h3 className="text-2xl sm:text-3xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                    Automating 100s of millions of images/year
                  </h3>
                  <p className="text-md sm:text-[1rem] text-center sm:text-left font-normal font-ibm-plex text-black leading-relaxed">
                    AI classifies every suspected defect 24/7, giving round-the-clock coverage and
                    reducing footprint in clean rooms.
                  </p>
                </div>
              </div>
              {/* Card 2 */}
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 sm:gap-8 p-6 sm:p-8">
                <div className="flex-shrink-0 w-20 sm:w-24 h-20 sm:h-24 bg-white border border-[#d7e7ff] rounded-lg flex items-center justify-center p-6 sm:p-7">
                  <img
                    src="/images/img_badge_dollar_orange_300.svg"
                    alt="Orange Badge"
                    className="w-12 sm:w-16 h-8 sm:h-12"
                  />
                </div>
                <div className="flex flex-col gap-3 sm:gap-4">
                  <h3 className="text-2xl sm:text-3xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                    30% Improvement in Cycle time
                  </h3>
                  <p className="text-md sm:text-[1rem] text-center sm:text-left font-normal font-ibm-plex text-black leading-relaxed">
                    Instant pass/fail decisions by AI keep the lots moving; hours get saved at each
                    review step and add savings in up to days for the fab.
                  </p>
                </div>
              </div>
              {/* Card 3 */}
              <div className="flex flex-col sm:flex-row items-center sm:items-center gap-6 sm:gap-8 p-6 sm:p-8">
                <div className="flex-shrink-0 w-20 sm:w-24 h-20 sm:h-24 bg-white border border-[#d7e7ff] rounded-lg flex items-center justify-center p-6 sm:p-7">
                  <img
                    src="/images/img_badge_dollar_orange_300_102x68.svg"
                    alt="Orange Badge 2"
                    className="w-12 sm:w-16 h-8 sm:h-12"
                  />
                </div>
                <div className="flex flex-col gap-3 sm:gap-4">
                  <h3 className="text-2xl sm:text-3xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                    1% Improvement in Yield
                  </h3>
                  <p className="text-md sm:text-[1rem] text-center sm:text-left font-normal font-ibm-plex text-black leading-relaxed">
                    By catching even the tiniest critical defects early, AI lets engineers correct
                    the process before scrap accumulates—saving thousands of dies that would have
                    been tossed. It also prevents unnecessary over-rejection that comes from
                    cautious manual screening.
                  </p>
                </div>
              </div>
              {/* Card 4 */}
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 sm:gap-8 p-6 sm:p-8">
                <div className="flex-shrink-0 w-20 sm:w-24 h-20 sm:h-24 bg-white border border-[#d7e7ff] rounded-lg flex items-center justify-center p-6 sm:p-7">
                  <img
                    src="/images/img_homepage_badge_secure.svg"
                    alt="Dollar Badge 2"
                    className="w-12 sm:w-16 h-8 sm:h-12"
                  />
                </div>
                <div className="flex flex-col gap-3 sm:gap-4">
                  <h3 className="text-2xl sm:text-3xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                    12% Reduction in Quality Issues
                  </h3>
                  <p className="text-md sm:text-[1rem] text-center sm:text-left font-normal font-ibm-plex text-black leading-relaxed">
                    Consistent, bias-free checks stop bad wafers from moving downstream, slashing
                    reworks, scraps, RMAs and customer complaints from field failures.
                  </p>
                </div>
              </div>
              {/* Card 5 */}
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 sm:gap-8 p-6 sm:p-8">
                <div className="flex-shrink-0 w-20 sm:w-24 h-20 sm:h-24 bg-white border border-[#d7e7ff] rounded-lg flex items-center justify-center p-6 sm:p-7">
                  <img
                    src="/images/img_badge_dollar_102x68.svg"
                    alt="Dollar Badge 3"
                    className="w-12 sm:w-16 h-8 sm:h-12"
                  />
                </div>
                <div className="flex flex-col gap-5 sm:gap-6">
                  <h3 className="text-2xl sm:text-3xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                    90% Reduction in man machine ratio:
                  </h3>
                  <p className="text-md sm:text-[1rem] text-center sm:text-left font-normal font-ibm-plex text-black leading-relaxed">
                    AI now does the work of dozens of operators, freeing people for higher-value
                    engineering and improvement tasks.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="w-full max-w-[1440px] py-2 sm:py-4 md:py-4 px-6 sm:px-7">
        <div className="flex flex-col items-center gap-10 sm:gap-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium font-ibm-plex text-center text-black px-4 sm:px-8">
            Loved by Yield Engineers
          </h2>
          {/* Testimonials Slider */}
          <div className="w-full">
            <Slider showArrows infinite className="items-stretch justify-stretch" maxSlideWidthPx={810}>
                {/* Testimonial 1 */}
                <div className="w-full h-full">
                  <div className="bg-white border border-[#e1eefe] rounded-lg shadow-[0px_4px_64px_#00000014] p-6 sm:p-8 h-full">
                    <div className="flex flex-col gap-8 sm:gap-9">
                      <div className="flex flex-col gap-6">
                        <h3 className="text-2xl sm:text-3xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                          Sixsense AI: Revolutionizing Defect Classification
                        </h3>
                        <p className="leading-[140%] sm:leading-[160%] md:leading-[160%] lg:leading-[160%] text-md text-center sm:text-left sm:text-[1rem] font-normal font-ibm-plex text-black">
                          "We've worked with Sixsense since the early days, and it's been a
                          game-changer. With their explainable AI tools and intuitive platform,
                          we've cut model launch time from months to just days, while consistently
                          hitting accuracy and automation targets. With Sixsense, a small group
                          manages, trains, and deploys AI models with ease. The models require
                          minimum retraining in production, and we have not seen defect escapees
                          post-launch. We're really excited about the future of AI and we're
                          confident that Sixsense will continue to be a leader in this field."
                        </p>
                        <span className="text-[1rem] sm:text-xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                          Yield Engineer
                        </span>
                      </div>
                      <img
                        src="/images/img_image_22.png"
                        alt="Company Logo"
                        className="w-56 sm:w-70 h-[2.5rem] sm:h-[3.75rem] object-contain"
                      />
                    </div>
                  </div>
                </div>
                {/* Testimonial 2 */}
                <div className="w-full h-full">
                  <div className="bg-white border border-[#e1eefe] rounded-lg shadow-[0px_4px_64px_#00000014] p-6 sm:p-8 h-full">
                    <div className="flex flex-col gap-8 sm:gap-9 pb-1">
                      <div className="flex flex-col gap-6">
                        <h3 className="leading-[160%] text-2xl sm:text-3x text-center sm:text-left font-semibold font-ibm-plex text-black">
                          Sixsense AI: Achieving Unparalleled Accuracy
                        </h3>
                        <p className="leading-[140%] sm:leading-[160%] text-center sm:text-left md:leading-[160%] lg:leading-[160%] text-md sm:text-[1rem] font-normal font-ibm-plex text-black">
                          "I evaluated multiple AI solutions — including from top global vendors —
                          but Sixsense stood out. ClassifAI hit 99% accuracy in just hours. The
                          model could learn defect patterns across multiple devices, making it
                          extremely adaptable to our manufacturing setup. The product was able to
                          integrate with different AOI tool vendor types, which made it a perfect
                          fit for operations. I’m very happy with the implementation."
                        </p>
                        <span className="text-[1rem] sm:text-xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                          Jasper Tay, Quality Assurance Manager
                        </span>
                      </div>
                      <img
                        src="/images/img_image_logo_statschip.png"
                        alt="JCET Logo"
                        className="w-56 sm:w-32 h-[2.5rem] sm:h-[2.5rem] object-contain mb-[3.375rem] sm:mb-1 md:mb-4  lg:mb-10"
                      />
                    </div>
                  </div>
                </div>
                {/* Testimonial 3 */}
                <div className="w-full h-full">
                  <div className="bg-white border border-[#e1eefe] rounded-lg shadow-[0px_4px_64px_#00000014] p-6 sm:p-8 h-full">
                    <div className="flex flex-col gap-8 sm:gap-9">
                      <div className="flex flex-col gap-6">
                        <h3 className="text-2xl sm:text-3xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                          Sixsense AI: Upholding Quality and Driving Innovation
                        </h3>
                        <p className="leading-[140%] sm:leading-[160%] text-center sm:text-left text-md sm:text-[1rem] font-normal font-ibm-plex text-black">
                          "Sixsense deep learning algorithms harness the power of extensive data,
                          empowering us to definitely address quality hurdles with unparalleled
                          precision. Furthermore, Sixsense's solution significantly reduces our
                          response time to quality challenges through its remarkably accurate
                          automated defect classifications. The outcome? A robust competitive
                          advantage and a substantial boost to our bottom line performance."
                        </p>
                        <span className="text-[1rem] sm:text-xl text-center sm:text-left font-semibold font-ibm-plex text-black">
                          Mark Tay, Quality Assurance Director
                        </span>
                      </div>
                      <img
                        src="/images/img_image_logo_statschip.png"
                        alt="JCET Logo"
                        className="w-56 sm:w-32 h-[2.5rem] sm:h-[2.5rem] object-contain mb-7 md:mb-[4.5rem] lg:mb-11"
                      />
                    </div>
                  </div>
                </div>
            </Slider>
          </div>
        </div>
      </section>
      {/* industry Highlight section */}
      <section className="w-full max-w-[1440px] px-6 sm:px-7">
        <div className="flex flex-col items-center gap-10 sm:gap-12 w-full">
          <h2 className="text-center justify-start text-black text-2xl lg:text-4xl font-medium">
            Sixsense in The News
          </h2>
          <div className="w-full">
            <IndustryHighlights />
          </div>
        </div>
      </section>
      {/* Backed By Section */}
      <section className="w-full max-w-full bg-[#fafafb] py-12 sm:py-[4.5rem]">
        <div className="w-full max-w-[1260px] mx-auto">
          <div className="flex flex-col items-center gap-8 sm:gap-10">
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-medium font-ibm-plex text-center text-black px-4 sm:px-6">
              Backed By:
            </h3>
            <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center gap-8 sm:gap-10">
              <img
                src="/images/img_image_55.png"
                alt="Backer 1"
                className="h-9 sm:h-11 w-auto object-contain"
              />
              <img
                src="/images/img_image_53.svg"
                alt="Backer 2"
                className="h-10 sm:h-12 w-auto object-contain"
              />
              <img
                src="/images/img_image_55_3.svg"
                alt="Backer 3"
                className="h-5 sm:h-7 w-auto object-contain"
              />
              <img
                src="/images/img_image_backer_alpha_1.svg"
                alt="Backer 4"
                className="h-9 sm:h-12 w-auto object-contain"
              />
              <img
                src="/images/img_image_backer_febe.svg"
                alt="Backer 5"
                className="h-10 sm:h-14 w-auto object-contain"
              />
              <img
                src="/images/img_image_55_5.svg"
                alt="Backer 5"
                className="h-10 sm:h-14 w-auto object-contain"
              />
              <img
                src="/images/img_image_55_4.svg"
                alt="Backer 6"
                className="h-5 sm:h-7 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      {/* <section className="w-full">
        <div className="w-full max-w-[1480px] mx-auto px-4 sm:px-6 lg:px-22">
          <div className="bg-white border border-[#e1eefe] rounded-lg p-6 sm:p-8 flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="flex flex-col gap-4">
              <h2 className="text-2xl sm:text-3xl font-medium font-['Work_Sans'] text-[#05090e] leading-tight">
                Improve your Quality Check Process Today
              </h2>
              <p className="text-[1rem] sm:text-xl font-normal font-ibm-plex text-[#4d6896]">
                Generate an endless flow of ideas in minutes. Polished, personalized and relevant
                copy – that is guaranteed to convert!
              </p>
            </div>
            <Button
              variant="primary"
              size="md"
              className="bg-[#214fce] text-white px-4 py-2.5 text-[1rem] sm:text-xl font-normal font-ibm-plex rounded-md flex-shrink-0"
              onClick={() => modalRef?.current?.open?.()}
            >
              Book Demo
            </Button>
          </div>
        </div>
      </section> */}
    </>
  );
}
